module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/ko/6-a5624956092cbe159b0803165bdaf8e2.jpg";